import { z } from 'zod';

import {
  GetAdminV1OrgMediaMimeType,
  GetAdminV1OrgMediaSort,
  MediaKind,
  type GetAdminV1OrgMediaParams,
} from '@nucleus-commerce/api-client/admin';

/** The "no folder" view in the URL; every other `folder` value is a folder id. */
export const UNFILED = 'unfiled';

/** URL search params of the media library; mirrors GET /admin/v1/org/media minus the cursor (pages load in place). */
export const mediaListSearchSchema = z.object({
  kind: z.enum(MediaKind).optional().catch(undefined),
  q: z.string().trim().max(120).optional().catch(undefined),
  missingAlt: z.boolean().optional().catch(undefined),
  mimeType: z.enum(GetAdminV1OrgMediaMimeType).optional().catch(undefined),
  sort: z.enum(GetAdminV1OrgMediaSort).optional().catch(undefined),
  folder: z.string().trim().min(1).max(64).optional().catch(undefined),
});

export type MediaListSearch = z.infer<typeof mediaListSearchSchema>;

/** List params for the library as the route loader and the page both build them; defaults stay out. */
export function mediaLibraryParams(
  search: MediaListSearch,
): Omit<GetAdminV1OrgMediaParams, 'cursor'> {
  return {
    limit: 48,
    ...(search.kind ? { kind: search.kind } : {}),
    ...(search.q ? { q: search.q } : {}),
    ...(search.missingAlt ? { missingAlt: 'true' as const } : {}),
    ...(search.mimeType ? { mimeType: search.mimeType } : {}),
    ...(search.folder === UNFILED
      ? { unfiled: 'true' as const }
      : search.folder
        ? { folderId: search.folder }
        : {}),
    ...(search.sort && search.sort !== 'newest' ? { sort: search.sort } : {}),
  };
}
